import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Row, Col, Input as T } from 'antd';
import Input from '../../helper/form/input';
import Footer from './Footer';
import Header from './HeaderLayout';
import Map from '../../helper/map/map';
import { Button, Icon } from 'antd';
const { TextArea } = T;

export class Contact extends Component {
  static propTypes = {
    others: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    nom: '',
    nom_is_valid: false,
    prenom: '',
    prenom_is_valid: false,
    textarea: ''
  }

  render() {
    return (
      <div className="others-contact">
        <Header />
        <Row className="form-contact">
          <form method="post" action={"mailto:contact@ynov.com?subject=Evenement Bordeaux - "+ this.state.nom.toUpperCase() + " " + this.state.prenom + "&body="+this.state.textarea   }>

          <Col xs={{ span: 22, offset: 1 }}>
              <Col xs={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} md={{ span: 22, offset: 1 }} lg={{ span: 14, offset: 0 }}>
                <Col span={24}>
                  <h1>Contact</h1>
                </Col>
                <Col span={24}>
                  <Input.Item
                    value={this.state.nom}
                    icon="edit"
                    placeholder="Nom"
                    onCheck={(nom_is_valid) => this.setState({ nom_is_valid })}
                    onChange={(nom) => this.setState({ nom })}
                    isValid={(valueNom) => valueNom.length >= 1}
                    status={{ success: '', error: 'Veuillez remplir votre nom' }}
                    checkOnChange
                    notEmpty
                  />
                </Col>
                <Col span={24}>
                  <Input.Item
                    value={this.state.prenom}
                    icon="edit"
                    placeholder="Prénom"
                    onCheck={(prenom_is_valid) => this.setState({ prenom_is_valid })}
                    onChange={(prenom) => this.setState({ prenom })}
                    isValid={(valuePrenom) => valuePrenom.length >= 1}
                    status={{ success: '', error: 'Veuillez remplir votre Prénom' }}
                    checkOnChange
                    notEmpty
                  />
                </Col>
                {/*<Col span={24}>
                  <Input.Email
                    value={this.state.email}
                    placeholder="E-mail"
                    onCheck={(email_is_valid) => this.setState({ email_is_valid })}
                    onChange={(email) => this.setState({ email })}
                    status={{ success: '', error: 'Veuillez remplir votre e-mail' }}
                    checkOnChange
                    required
                  />
                </Col>
                <Col span={24}>
                  <Input.Item
                    value={this.state.objet}
                    icon="edit"
                    placeholder="Objet"
                    onCheck={(objet_is_valid) => this.setState({ objet_is_valid })}
                    onChange={(objet) => this.setState({ objet })}
                    isValid={(valueObjet) => valueObjet.length >= 1}
                    status={{ success: '', error: 'Veuillez remplir l objet' }}
                    checkOnChange
                    notEmpty
                  />
                </Col>*/}
                <Col span={24}>
                  <TextArea rows={4} value={this.state.textarea} onChange={(e) => this.setState({ textarea: e.target.value })} />
                </Col>
                <Col span={24}>
                  <Button 
                    disabled={ !(this.state.nom_is_valid && this.state.prenom_is_valid) }
                    style={{ width: '100%' }}  type="primary" htmlType="submit">
                    <Icon type="edit" />Envoyer
                  </Button>
                </Col>
              </Col>
              <Col className="info-adress" xs={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} md={{ span: 22, offset: 1 }} lg={{ span: 8, offset: 1 }}>
              <Col style={{marginBottom:'20px'}} span={24}>
                <strong>CAMPUS YNOV</strong>
              </Col>
              <Col style={{marginBottom:'20px'}} span={24}>
                <p>89 Quai des chartrons</p>
                <p>33000 BORDEAUX</p>
              </Col>
              <Col span={24}>
                <p>Horaires du Lundi au Vendredi</p>
                <p>8h - 18h</p>
              </Col>
              <Col span={24} className="google-map" style={{height: 200}}>
                <Map location="geo:44.854165,-0.566282?q=Ynov"/>
              </Col>
              </Col>
          </Col>
          </form>
        </Row>
        <Footer />
      </div>

    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    others: state.others,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);



// WEBPACK FOOTER //
// ./src/features/others/Contact.js